import React from 'react';
import { Link } from 'react-router-dom';
import scotbaseMark from '../assets/scotbase-original-mark.png';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img className="nav-logo-mark" src={scotbaseMark} alt="" />
          <span className="nav-logo-wordmark">
            <span className="nav-logo-name">SCOTBASE</span>
            <span className="nav-logo-rule" />
            <span className="nav-logo-subtitle">ENTERTAINMENTS</span>
          </span>
        </Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/artists" className="nav-link">
              Performance Acts
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dinner-speakers" className="nav-link">
              Dinner Speakers
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">
              About Us
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link">
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
